module.exports = __webpack_public_path__ + "static/img/sdmp.1cc9080.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/sdmp.png
// module id = qhYi
// module chunks = 0